import { call, all, put, takeLatest } from "redux-saga/effects";
import { doGet, doPut } from "../utils/request";
import {
  getCirclesOfDistrictSuccess,
  getCirclesOfDistrictFail,
  assignCirclesToTISuccess,
  assignCirclesToTIFail,
} from "../actionCreators/Circles";

function* getCirclesOfDistrict({ obj }) {
  try {
    const response = yield doGet(`/dropdowns/getCirclesOfDistrict?districtId=${obj?.districtId?obj?.districtId:obj?.district_id}`);
    yield put(getCirclesOfDistrictSuccess(response.data));
  } catch (err) {
    yield put(getCirclesOfDistrictFail(err.response.data.message || err.message));
    yield put(getCirclesOfDistrictFail());
  }
}

function* assignCirclesToTI({ obj }) {
  try {

    const response = yield doPut(`/userti/assignIndividualCirclesToTi`, obj);
    yield put(assignCirclesToTISuccess(response.data));
  } catch (err) {
    yield put(assignCirclesToTIFail("err"));
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_CIRCLES_OF_DISTRICT", getCirclesOfDistrict),
    takeLatest("ASSIGN_CIRCLES_TO_TI", assignCirclesToTI),
  ]);
}
